import React, { useState } from 'react';
import CyberBadge from '../common/CyberBadge';
import { Dumbbell, Plus, Eye, Calendar, Clock } from 'lucide-react';

export default function FitnessView({
  rooms = [],
  selectedSlotRoom,
  setSelectedSlotRoom,
  selectedSlots = [],
  setSelectedSlots,
  selectedSlotDate,
  setSelectedSlotDate,
  onFetchRoomSlots,
  onSelectDrawer,
  onOpenCreateModal,
}) {
  const [activeCategory, setActiveCategory] = useState('all');

  const fitnessRooms = rooms.filter(
    (r) =>
      r.moduleType === 'fitness_sports' ||
      r.categoryType === 'gym' ||
      r.categoryType === 'ground_booking' ||
      r.categoryType === 'turf'
  );

  const displayFitness = fitnessRooms.length > 0 ? fitnessRooms : [
    {
      _id: 'fit-101',
      title: 'Malwa Turf Sports Ground',
      city: 'Indore, MP',
      price: 1200,
      priceType: 'hour',
      categoryType: 'ground_booking',
      status: 'approved',
    },
    {
      _id: 'fit-102',
      title: 'Gold Gym Vijay Nagar Arena',
      city: 'Indore, MP',
      price: 2500,
      priceType: 'month',
      categoryType: 'gym',
      status: 'approved',
    },
  ];

  return (
    <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
      {/* Header Banner */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h1 className="page-title" style={{ fontSize: '1.75rem', fontWeight: 900, color: 'var(--text-primary)', margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Dumbbell size={28} style={{ color: 'var(--neon-cyan)' }} /> Fitness & Ground Turfs Booking
          </h1>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-secondary)', marginTop: '4px' }}>
            Gym memberships, cricket turf grounds, and hourly sports facility bookings.
          </p>
        </div>

        <button
          className="btn btn-cyan"
          style={{ padding: '10px 20px', borderRadius: '10px', fontSize: '0.88rem' }}
          onClick={() => onOpenCreateModal('fitness_sports', 'ground_booking')}
        >
          <Plus size={16} /> Add Turf / Gym Space
        </button>
      </div>

      {/* SLEEK HIGH-TECH LIST VIEW */}
      <div className="cyber-list-container">
        {displayFitness.map((item, idx) => (
          <div
            key={item._id}
            className="cyber-list-row list-row-animate"
            style={{ animationDelay: `${idx * 0.08}s` }}
          >
            {/* Left Info Column */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '10px',
                  background: 'rgba(0, 240, 255, 0.12)',
                  border: '1px solid rgba(0, 240, 255, 0.35)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 0 12px rgba(0, 240, 255, 0.2)',
                }}
              >
                <Dumbbell size={20} style={{ color: 'var(--neon-cyan)' }} />
              </div>
              <div>
                <div style={{ fontSize: '1.05rem', fontWeight: 800, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {item.title}
                  <CyberBadge status={item.status || 'approved'} />
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>📍 {item.city || 'Indore, MP'}</span>
                  <span>•</span>
                  <span className="badge badge-cyan" style={{ fontSize: '0.65rem' }}>
                    {item.categoryType ? item.categoryType.toUpperCase() : 'SPORTS TURF'}
                  </span>
                </div>
              </div>
            </div>

            {/* Right Action Column */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '1.15rem', fontWeight: 900, color: 'var(--neon-green)', fontFamily: 'var(--font-mono)' }}>
                  ₹{item.price.toLocaleString()} <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>/ {item.priceType || 'hour'}</span>
                </div>
                <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '2px' }}>Slot Booking Enabled</div>
              </div>

              <button
                className="btn btn-purple"
                style={{ padding: '8px 14px', fontSize: '0.8rem' }}
                onClick={() => {
                  setSelectedSlotRoom(item);
                  onFetchRoomSlots(item._id, selectedSlotDate);
                }}
              >
                <Clock size={14} /> Slots Matrix
              </button>

              <button
                className="btn btn-outline"
                style={{ padding: '8px 14px', fontSize: '0.8rem' }}
                onClick={() => onSelectDrawer(item, 'room')}
              >
                <Eye size={14} /> Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
